export { default } from '@shikijs/langs/reg'
